/**
 * `s779` (владелец 11.10.2026: «если нет действий во всей системе больше 5 минут, не двигается мышка и
 * прочее… как заставки на компьютере»). Когда человек последний раз что-то делал в панели — в любой её
 * вкладке: отметка общая на браузер, чтобы работа в соседней вкладке не считалась тишиной в этой.
 */
const KLYUCH = 'opsmind.tel.aktivnost';
/** В общее хранилище пишем не чаще: движение мыши — десятки событий в секунду. */
const PISAT_NE_CHASHCHE_MS = 3000;

/** Через сколько тишины браузер говорит «затих» (`POROG_MS` в `prisutstvie.ts`). */
const DETEKTOR_ZAMECHAET_MS = 60_000;

let zdes = Date.now();
let zapisano = 0;
/**
 * `s781`: что браузер говорит о человеке за компьютером (см. `prisutstvie.ts`): true — трогает мышь или
 * клавиатуру в любой программе, false — затих или запер экран, null — браузер молчит, считаем по
 * вкладкам панели.
 */
let zaKompyuterom: boolean | null = null;

/** Человек только что двигал мышью, нажимал клавишу или касался экрана. */
export function otmetitAktivnost(now = Date.now()): void {
  zdes = now;
  if (now - zapisano < PISAT_NE_CHASHCHE_MS) return;
  zapisano = now;
  try { window.localStorage.setItem(KLYUCH, String(now)); } catch { /* хранилище закрыто — считаем по этой вкладке */ }
}

/** Отметка не раньше названной минуты: браузер сказал о тишине позже, чем она началась. */
function otmetitNeRanshe(kogda: number): void {
  zdes = Math.max(zdes, kogda);
  try {
    if (kogda > (Number(window.localStorage.getItem(KLYUCH) ?? 0) || 0)) window.localStorage.setItem(KLYUCH, String(kogda));
  } catch { /* хранилище закрыто — считаем по этой вкладке */ }
}

/**
 * `s781`: браузер сообщил, за компьютером ли человек. Пока он за компьютером, тишины нет, где бы он ни
 * работал; затих — отсчёт идёт с минуты, когда затих (`tishinaUzheMs` назад), а не с последнего
 * движения в панели.
 */
export function postavitZaKompyuterom(da: boolean | null, tishinaUzheMs = 0, now = Date.now()): void {
  const bylo = zaKompyuterom;
  zaKompyuterom = da;
  if (da === true) otmetitAktivnost(now);
  else if (da === false && bylo === true) otmetitNeRanshe(now - tishinaUzheMs);
}

/** По чему сейчас считается тишина: по всему компьютеру или только по вкладкам панели. */
export function slezhenie(): 'computer' | 'panel' {
  return zaKompyuterom === null ? 'panel' : 'computer';
}

/** Последнее действие человека — за компьютером, если браузер это сообщает, иначе в панели (в этой вкладке или в соседней). */
export function poslednyayaAktivnost(): number {
  if (zaKompyuterom === true) {
    // `s818`: «за компьютером» знает только эта вкладка — кладём в общую отметку, чтобы соседние
    // вкладки, чей детектор молчит (браузер их усыпил в фоне), не считали тишину от старого движения.
    // Браузер говорит «активен», пока движение было не дальше своего порога назад, — отметка не новее.
    const now = Date.now();
    otmetitNeRanshe(now - DETEKTOR_ZAMECHAET_MS);

    return now;
  }
  let sosed = 0;
  try { sosed = Number(window.localStorage.getItem(KLYUCH) ?? 0) || 0; } catch { /* см. выше */ }

  return Math.max(zdes, sosed);
}

const SOBYTIYA = ['mousemove', 'mousedown', 'keydown', 'wheel', 'touchstart', 'scroll'] as const;

/**
 * Слушать действия человека в этом окне; возвращает отписку.
 *
 * `s818` (бой 14.10.2026: Наталье ставило «Отошёл» в ту секунду, когда она возвращалась во вкладку):
 * переход во вкладку или окно — тоже действие человека, хотя щелчок по ярлыку вкладки странице не виден.
 */
export function slushatAktivnost(): () => void {
  const otmetit = () => otmetitAktivnost();
  const vernulsya = () => { if (document.visibilityState === 'visible') otmetitAktivnost(); };
  SOBYTIYA.forEach((s) => window.addEventListener(s, otmetit, { capture: true, passive: true }));
  window.addEventListener('focus', otmetit);
  document.addEventListener('visibilitychange', vernulsya);

  return () => {
    SOBYTIYA.forEach((s) => window.removeEventListener(s, otmetit, { capture: true }));
    window.removeEventListener('focus', otmetit);
    document.removeEventListener('visibilitychange', vernulsya);
  };
}

/** Для проверок: начать отсчёт тишины заново. */
export function sbrositAktivnost(now = Date.now()): void {
  zdes = now;
  zapisano = 0;
  zaKompyuterom = null;
  try { window.localStorage.removeItem(KLYUCH); } catch { /* см. выше */ }
}
